module.exports = [{
      plugin: require('/Users/peiwen/Projects/fotor-marketing-site/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Fotor","short_name":"Fotor","start_url":"/","icon":"static/favicon.svg"},
    },{
      plugin: require('/Users/peiwen/Projects/fotor-marketing-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
